import { render } from "./DefaultHeader.vue?vue&type=template&id=00395d7e&scoped=true&ts=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&lang=ts"

import "./DefaultHeader.vue?vue&type=style&index=0&id=00395d7e&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00395d7e"]])

export default __exports__